// extracted by mini-css-extract-plugin
export default {"downloadBanner":"downloadBanner_downloadBanner__Lh1KP"};